const comments = [
  {
    name: '漫画迷小李',
    text: '发现51动漫网之后就把其他阅读软件都卸了，更新速度真的快，咒术回战每周四中午就能看到最新话，太给力了！下拉式阅读在手机上体验超棒。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20male%20avatar%20portrait%20with%20friendly%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20modern%20anime%20character%20design&width=80&height=80&seq=51anime-avatar-01&orientation=squarish',
  },
  {
    name: '追番少女',
    text: '国漫专区太赞了！斗破苍穹从第一话追到现在，51动漫网的排版和加载速度都很好，不用注册直接看，这才是真正的良心网站。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20avatar%20portrait%20with%20gentle%20smile%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20cute%20modern%20anime%20character%20design&width=80&height=80&seq=51anime-avatar-02&orientation=squarish',
  },
  {
    name: '热血漫大叔',
    text: '海贼王老粉了，从第一话追到现在。51动漫网上看漫画很方便，更新也及时，艾尔巴夫篇每周都有，推荐给身边好多朋友了。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20mature%20male%20avatar%20portrait%20with%20confident%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20strong%20modern%20anime%20character%20design&width=80&height=80&seq=51anime-avatar-03&orientation=squarish',
  },
  {
    name: '二次元新手上路',
    text: '刚入坑动漫不久，51动漫网的热门排行和专题合集对我帮助很大，从鬼灭之刃开始看起，现在已经沉迷了哈哈。推荐新手从这里开始！',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20teenager%20avatar%20portrait%20with%20excited%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20enthusiastic%20modern%20anime%20character%20design&width=80&height=80&seq=51anime-avatar-04&orientation=squarish',
  },
  {
    name: '深度漫评人',
    text: '做动漫内容创作三年了，51动漫网是我重要的素材来源。更新快、分类全、体验好，葬送的芙莉莲的分析文章就是在这里追更时获得的灵感。',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20intellectual%20female%20avatar%20portrait%20with%20thoughtful%20expression%2C%20simple%20warm%20background%2C%20clean%20illustration%20style%2C%20analytical%20modern%20anime%20character%20design&width=80&height=80&seq=51anime-avatar-05&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">读者心声</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            来自51动漫网读者的真实反馈与鼓励
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((comment, idx) => {
            const isWide = idx === 0;
            const colSpan = isWide ? 'md:col-span-2' : '';

            return (
              <div
                key={comment.name}
                className={`${colSpan} bg-background-100 rounded-lg border border-background-200/60 p-5`}
              >
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                  </div>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                    <div className="flex items-center gap-0.5 text-accent-500">
                      {Array.from({ length: 5 }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-xs"></i>
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{comment.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}